import { ButtonType, ButtonWidget, FlyoutListMenuWidget } from '@tableau/widgets';
import * as React from 'react';
import { Messages } from '../../../../../gen-src/Localize';
import { RemoteType } from '../../../../../gen-src/queries';
import { ColumnDetailsDialogQueryWrapper } from '../ColumnDetails/ColumnDetailsDialog';
import { inlineActionsMenuButtonStyle } from '../style/ColumnAndFieldDetailsStyles';
import { ActionStatusIcon, ColumnActionItems, ListMenuStyle, useActionsMenu } from './InlineActionsMenuHelper';

const testId =  'column-inline-actions';

const noop = () => { return; };

export interface ColumnInlineActionsMenuProps {
  readonly columnId: string;
  readonly columnLuid: string;
  readonly columnName: string;
  readonly columnRemoteType: RemoteType;
  readonly tableVizportalId: string;
  readonly canUpdate: boolean;
}

export function ColumnInlineActionsMenu(props: ColumnInlineActionsMenuProps): JSX.Element | null {
  const { columnId, columnLuid, columnName, columnRemoteType, tableVizportalId, canUpdate } = props;

  const [buttonEl, setButtonEl] = React.useState<HTMLElement | null>(null);

  const actionsMenu = useActionsMenu({
    columnLuid: columnLuid,
    columnName: columnName,
    columnRemoteType: columnRemoteType
  });

  if (!columnId) {
    return null;
  }

  return (<>
    <ButtonWidget
      buttonType={ButtonType.LowEmphasis}
      title={Messages.Actions()}
      testId={testId + '-button'}
      getContent={(s) => <ActionStatusIcon hover={s.hover || s.active || false} />}
      buttonRef={setButtonEl}
      onClick={() => actionsMenu.setIsMenuShowing(!actionsMenu.isMenuShowing)}
      style={inlineActionsMenuButtonStyle}
      disabled={!canUpdate}
      tabIndex={-1}
    />
    {
      actionsMenu.isMenuShowing && <FlyoutListMenuWidget
        anchorEl={buttonEl}
        menuItemInfos={ColumnActionItems({ columnLuid: columnLuid, canUpdate: canUpdate})}
        testId={testId + '-menu'}
        toggleEl={buttonEl}
        menuStyle={ListMenuStyle}
        onSelect={(value: string) => {
          actionsMenu.onSelect(value);
        }}
        requestCloseAll={() => {
          actionsMenu.setIsMenuShowing(false);
        }}
      />}
      {
        actionsMenu.isDialogShowing && (
          <ColumnDetailsDialogQueryWrapper
            columnId={columnId}
            tableVizportalId={tableVizportalId}
            onClose={() => actionsMenu.setIsDialogShowing(false)}
            afterDescriptionAndTagsChange={noop}
            detailsAction={actionsMenu.action ?? undefined}
          />
        )
      }
  </>);
}